// extracted by mini-css-extract-plugin
module.exports = {"fiction_box":"fiction_box-OFAFrmW0"};